import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { fetchAppointmentsByQueueType } from 'modules/queues/common/actions/fetchAppointmentsByQueueType';

import AppointmentsSidebarFetchErrorPlaceholder from './AppointmentsSidebarFetchErrorPlaceholder';

export default connect(
  null,
  { fetchAppointmentsByQueueType },
)(injectIntl(AppointmentsSidebarFetchErrorPlaceholder));
